import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["aria-hidden"]
const _hoisted_2 = ["fill", "width", "height"]

import { useAttrs } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'InsertChartOutlined',
  props: {
  decorative: {
    type: Boolean,
    default: false,
  },
  fillColor: {
    type: String,
    default: 'currentColor',
  },
  size: {
    type: Number,
    default: 24,
  },
},
  setup(__props) {



const attrs = useAttrs();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _mergeProps({
    "aria-hidden": __props.decorative,
    class: [[_unref(attrs).class, _unref(attrs).staticClass], "material-design-icon account-icon"],
    role: "img"
  }, _unref(attrs)), [
    (_openBlock(), _createElementBlock("svg", {
      fill: __props.fillColor,
      class: "material-design-icon__svg",
      width: __props.size,
      height: __props.size,
      viewBox: "0 0 24 24"
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      _createElementVNode("path", { d: "M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2.5 2.1h-15V5h15v14.1zm0-16.1h-15c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" }, null, -1)
    ]))], 8, _hoisted_2))
  ], 16, _hoisted_1))
}
}

})